import App from "./src/client-expo/App";
export default App;